import React from 'react'
import _ from 'lodash'
import Ticket from './Ticket'
import VoucherInput from '../../vouchers/VoucherInput'
import LOCALE from '../OrderLocale'
import { VOUCHER_TYPES } from '../../../../api/api-constants';


export default class AvailableTickets extends React.Component {
    constructor(props) {
        super(props);
   
        this.state = {
      
            selectedPoints: props.order.selected.clubCardPoints || 0,
            error:''
        }

        this.canIncrementTotalQuantity = this.canIncrementTotalQuantity.bind(this);
        this.canIncrementTotalPoints   = this.canIncrementTotalPoints.bind(this);
        this.incrementTotalQuantity    = this.incrementTotalQuantity.bind(this);
        this.decrementTotalQuantity    = this.decrementTotalQuantity.bind(this);
        this.isIncrementingPossible = this.isIncrementingPossible.bind(this);
        this.isDecrementingPossible = this.isDecrementingPossible.bind(this)
    }

   

    isDecrementingPossible() {
        const { order } = this.props;

        let totalTicketQuantity = order.selected.totalTicketQuantity;
     
        const {  minWebTicketCount } = this.props

        if (totalTicketQuantity == minWebTicketCount ) {
            return true
        }
       
        else return false
       
    }

    isIncrementingPossible() {

        const { maxWebTicketCount, minWebTicketCount,order  } = this.props
        let totalTicketQuantity = order.selected.totalTicketQuantity;

       
       
        if (totalTicketQuantity > 0) { 
            if (minWebTicketCount > 0 && maxWebTicketCount > 0 && (totalTicketQuantity ===  maxWebTicketCount)) {
              
            return false
        }
            else if (minWebTicketCount === 0 && maxWebTicketCount > 0 && totalTicketQuantity === maxWebTicketCount) {
              

            return false
        }
     
        
            else return true
        }
        else return true
    }

    canIncrementTotalQuantity() {
        const { order } = this.props;
   
       let  totalTicketQuantity   = order.selected.totalTicketQuantity;
      
        const newTotal = totalTicketQuantity + 1;
    
        return newTotal <= Math.max(order.buyMax, order.reserveMax) ;
    }

    incrementTotalQuantity() {
        const { maxWebTicketCount, minWebTicketCount,order } = this.props

        let totalTicketQuantity = order.selected.totalTicketQuantity;

      
        this.setState({ totalTicketQuantity: ++totalTicketQuantity })

        if (minWebTicketCount > 0 && maxWebTicketCount > 0 && (totalTicketQuantity === maxWebTicketCount)) {
           
            this.setState({ error: 'Antal af billetter skal være mellem ' + minWebTicketCount + ' og ' + maxWebTicketCount })
        }
        else if (minWebTicketCount === 0 && maxWebTicketCount > 0 && totalTicketQuantity === maxWebTicketCount) {
            this.setState({ error: 'Antal af billetter skal være maximum ' + maxWebTicketCount })
           
        }
       
    }

    decrementTotalQuantity() {
        const { order } = this.props;

        let totalTicketQuantity = order.selected.totalTicketQuantity;

        let { error } = this.state;
        const { maxWebTicketCount, minWebTicketCount } = this.props

        if (totalTicketQuantity > 0) {
            this.setState({ totalTicketQuantity: --totalTicketQuantity })
            if (error && totalTicketQuantity < maxWebTicketCount) {
                this.setState({error:''})
            }
        }
    }

    canIncrementTotalPoints(incrementBy) {
        const { selectedPoints } = this.state;
        const { order } = this.props;
        const newTotal = selectedPoints + incrementBy;
        const canIncrement = newTotal <= order.clubCard.points;
        if (canIncrement) this.setState({ selectedPoints: newTotal });;
        return canIncrement;
    }

    generateTickets() {
        const { order, ticketQuantityChanged, bioDkActive, freeSeats, appLocale, discountEnabled, default_tickets, minWebTicketCount, maxWebTicketCount, site_type } = this.props;
        const { totalTicketQuantity } = this.state
      
        const selected = order.selected;
        let selectedIdsHandled = [];
        let tickets = [];
      
       
        _.forEach(order.availableTickets, (available,index) => {
            const selectedTicket = _.find(selected.tickets, (ticket) => { return available.id === ticket.id; });
            if (selectedTicket != null) selectedIdsHandled.push(selectedTicket.id);

            tickets.push(<Ticket key={available.id}
                appLocale={appLocale}
                default_tickets={default_tickets }
                availableTicket={available}
                selectedTicket={selectedTicket}
                order={order}
                site_type={site_type }
                totalTicketQuantity={order.selected.totalTicketQuantity}
                maxWebTicketCount={maxWebTicketCount }
                minWebTicketCount={index === 0 && minWebTicketCount }
                isDecrementingPossible={this.isDecrementingPossible }
                isIncrementingPossible={this.isIncrementingPossible }
                canIncrementTotalQuantity={this.canIncrementTotalQuantity}
                incrementTotalQuantity={this.incrementTotalQuantity}
                decrementTotalQuantity={this.decrementTotalQuantity}
                ticketQuantityChanged={ticketQuantityChanged}
                bioDkActive={bioDkActive}
                canIncrementTotalPoints={this.canIncrementTotalPoints}
                freeSeats={freeSeats}
                discountEnabled={discountEnabled}
            />);
        });

        //Checking if there have been added other selected tickets that are not in available tickets, such as biografklub dk
        if (bioDkActive && selectedIdsHandled.length < selected.tickets.length) {
            _.forEach(selected.tickets, (ticket) => {
                const existing = _.find(selectedIdsHandled, (id) => { return id === ticket.id });
                if (!existing) {
                    tickets.push(<div key={ticket.id} className="Ticket">
                        <h4>{ticket.name}</h4>
                        <div className="quantity">{ticket.quantity}</div>
                    </div>)
                }
            });
        }

        return tickets;
    }

    getVoucherText() {
        const { configuration, order, appLocale } = this.props;
      
        if (!configuration.giftCardsEnabled && order.bioKlubDk.available)
            return <span>{LOCALE[appLocale].discountTextBioKlubDk}</span>;
        else if (configuration.giftCardsEnabled && !order.bioKlubDk.available)
            return <span>{LOCALE[appLocale].discountTextGiftCard}</span>;
        else if (configuration.giftCardsEnabled && order.bioKlubDk.available)
            return <span>{LOCALE[appLocale].discountTextBoth}</span>;
        else return null;
    }

    getLocationText() {
        const { configuration, locationId } = this.props;
        const locationText = _.find(configuration.locationTexts, (text) => { return text.id == locationId });
        return locationText ? locationText.text : null;
    }

    render() {
        const { initialFetchDone, discountEnabled, discountActivated, appLocale, submitDiscountCode, appHeightChanged, order, site_type } = this.props;
        const tickets = initialFetchDone ? this.generateTickets() : null;
        const voucherText = this.getVoucherText();
        const locationText = this.getLocationText();
        const { error } = this.state;
      
        const errorMessage = error ? <div style={{ paddingTop: '20px' }} className="error">{error}</div> : null;
       

        return (
            <div className="AvailableTickets">
                {site_type == 3 ? <div className='choose_the_tkt'> 1. Vælg antal billetter</div> : null}

                {locationText ? <div className="location-text" dangerouslySetInnerHTML={{ __html: locationText }} /> : null}
                {tickets}
               
                {!discountActivated && discountEnabled ? <div className="discount">
                    <VoucherInput type={VOUCHER_TYPES.DISCOUNT}
                        appLocale={appLocale}
                        vouchersChanged={submitDiscountCode}
                        appHeightChanged={appHeightChanged}
                    /> {voucherText}</div> : null}
            </div>
        )
    }
}